import "./App.css";
import React, { Component, PropTypes } from "react";
import {
  EditorState,
  Modifier,
  convertToRaw,
  stateFromHTML,
  ContentState,
  RichUtils
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import htmlToDraft from "html-to-draftjs";
import CopyToClipboard from "react-copy-to-clipboard";
import "react-virtualized/styles.css";

import AddRelatedProducts from "./AddRelatedProducts";
import emojis from "./emoji";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const htmlText = `
`;

const { contentBlocks, entityMap } = htmlToDraft(htmlText);
const contentState = ContentState.createFromBlockArray(
  contentBlocks,
  entityMap
);
const editorState = EditorState.createWithContent(contentState);

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};
const convertLineBreaks = text => {
  let t = text.replaceAll("<p>", "");
  t = t.replaceAll("</p>", "");
  t = t.replaceAll("<br>", "");
  return t;
};

const stripNewline = text => text;

const options = {
  inlineStyles: {
    // Override default element (`strong`).
    UNDERLINE: {
      element: "span",
      style: { textDecoration: "underline" }
    }
  }
};

class EditorConvertToHTML extends Component {
  state = {
    editorState: EditorState.createWithContent(contentState),
    copied: false
  };

  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState
    });
  };

  handleReturn = (e, editorState) => {
    var selection = this.state.editorState.getSelection();
    var content = this.state.editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getAnchorKey());
    this.onEditorStateChange(
      RichUtils.insertSoftNewline(this.state.editorState)
    );
    return true;
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className="container">
        <nav className="navbar">
          <div className="container">
            <ul className="navbar-list">
              <li className="navbar-item">
                <a className="navbar-link" href="/">
                  &lt; Back to Bearwood Labs
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div style={{ textAlign: "center" }}>
          <h3 style={{ marginBottom: 0 }}>Product Description Editor</h3>
          <small>
            Bold, italics, symbols and links for TPT product descriptions
          </small>
          <hr />
        </div>
        <div className="row">
          <div className="six columns">
            <div className="editor">
              <div className="editor-content">
                <Editor
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  // handleReturn={this.handleReturn}
                  toolbar={{
                    options: ["inline", "link", "emoji"],
                    inline: {
                      options: ["bold", "italic", "underline"],
                      bold: { className: "bordered-option-classname" },
                      italic: { className: "bordered-option-classname" },
                      underline: { className: "bordered-option-classname" }
                    },
                    textAlign: {
                      options: ["left", "center"],
                      left: { className: "demo-option-custom" },
                      center: { className: "demo-option-custom" }
                    },
                    emoji: {
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      emojis: emojis()
                    }
                  }}
                  // toolbarCustomButtons={[<AddRelatedProducts />]}
                  onEditorStateChange={this.onEditorStateChange}
                />
              </div>
            </div>
          </div>
          <div className="six columns">
            <div className="">
              <div style={{ textAlign: "right" }}>
                <CopyToClipboard
                  text={convertLineBreaks(
                    stateToHTML(editorState.getCurrentContent(), options)
                  )}
                  onCopy={() => {
                    this.setState({ copied: true });
                    setTimeout(() => this.setState({ copied: false }), 5000);
                  }}
                >
                  <button className="button button-primary">
                    {this.state.copied === false
                      ? "Copy to clipboard"
                      : "Copied"}
                  </button>
                </CopyToClipboard>
              </div>
              <textarea
                id="foo"
                value={convertLineBreaks(
                  stateToHTML(editorState.getCurrentContent(), options)
                )}
                readOnly
              />
            </div>
          </div>
        </div>
        <hr />
        <footer>
          <div style={{ textAlign: "center" }}>
            <h6>
              made with ❤️ from <a href="/">Bearwood Labs</a>
            </h6>
          </div>
        </footer>
      </div>
    );
  }
}
export default EditorConvertToHTML;



// WEBPACK FOOTER //
// ./src/App.js